import {
  indexLayoutSidebar,
  leftWidth,
  rightWidth,
  canvasFirstRightWidth,
  leftMaxWidth,
  defaultPaddingForTouchDevices,
} from '@sketch/constants'

export const sidebar = {
  indexLayoutSidebar,
  leftWidth,
  leftMaxWidth,
  rightWidth,
  canvasFirstRightWidth,
  defaultPaddingForTouchDevices,
} as const
